import { render, staticRenderFns } from "./SettingsEditorPullout.vue?vue&type=template&id=4801f526&scoped=true&"
import script from "./SettingsEditorPullout.vue?vue&type=script&lang=js&"
export * from "./SettingsEditorPullout.vue?vue&type=script&lang=js&"
import style0 from "./SettingsEditorPullout.vue?vue&type=style&index=0&id=4801f526&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4801f526",
  null
  
)

export default component.exports